import elementTable from "@/package/elementTable/elementTable";
elementTable.install = Vue => Vue.component(elementTable.name, elementTable);  //表单组件
export default elementTable
